import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import { StringUtilities } from "../../../utilities/strings";
import { ChartDataEntry } from "../../../models/components/chart.models";
import * as Enumerable from "linq";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../utilities/reflection";

@autoinject()
@transient()
export class Legend {

    @bindable
    public data: ChartDataEntry[];

    @bindable
    public format: string = "{0}";

    @bindable
    public params: string = "label";

    @computedFrom(Reflection.getPropertyPath<Legend>(z => z.data), Reflection.getPropertyPath<Legend>(z => z.data.length))
    get entries(): ChartDataEntry[] {
        return this.data ? Enumerable.from(this.data).where(x=> x.label == "All")
        .concat(Enumerable.from(this.data).where(x => x.label != "All")
        .orderByDescending(x => x.data)).toArray() : [];
    }

    clickItem(item:ChartDataEntry, index: number){
        const paramsEvent: any = { detail: { label: item.label, index: index, isLengend: true }, bubbles: true };
        const chartItemClick: CustomEvent = new CustomEvent("legend-item-click", paramsEvent);
        this.element.dispatchEvent(chartItemClick);
    }

    constructor(private element:Element){}
}

export class LegendStringFormatValueConverter {
    toView(value, args) {
        const item: ChartDataEntry = value;
        let format = args.format;
        const params = args.params.split(',');

        for (let i = 0; i < params.length; i++) {
            const index = "{" + i + "}";
            const regex = new RegExp(StringUtilities.escapeRegExp(index), 'g');
            format = format.replace(regex, this.getLocaleFormatValue(item[params[i]]));
        }
        return format;
    }

    //format the value if number to locale
    getLocaleFormatValue(data){
        if (!isNaN(parseFloat(data)) && isFinite(data)){
            return Number(data).toLocaleString();
        }
        else return data;
    }
}
